import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types';

export const columns: TableColumn[] = [
  { id: 'fromDateTime', label: 'From', align: 'left', sortDisabled: true },
  { id: 'toDateTime', label: 'To', align: 'left', sortDisabled: true },
  { id: 'name', label: 'Name', align: 'left', sortDisabled: true },
  {
    id: 'gate',
    label: 'Gate',
    align: 'left',
    sortDisabled: true,
  },
  {
    id: 'vesselOps',
    label: 'Vessel Ops',
    align: 'left',
    sortDisabled: true,
  },
  { id: 'remarks', label: 'Remarks', align: 'left', sortDisabled: true },
  { id: 'actions', label: 'Actions', align: 'right', sortDisabled: true },
];

const stringMapper = {
  YES: 'Yes',
  NO: 'No',
  PARTIAL: 'Partial',
};

export const mapString = (val: string) => stringMapper[val];

export const getDateFromDateTime = (date: string) => date.substring(0, 10);

export const getTimeFromDateTime = (date: string) => date.substring(11, 16);

export const getDateTimeFromTime = (date: string, time: string) => `${getDateFromDateTime(date)}T${time}`;

export const getDateTimeFromDate = (date: string, day: string) => `${day}T${getTimeFromDateTime(date)}`;
